import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ColorInputs from '../../components/ColorInputs/ColorInputs';
import { connect } from 'react-redux';
import { updateColorRequestAction } from '../../store/color/colorActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateColor = ({ updateColorRequest, isLoading, updateColorData, colorList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const colorFromList = colorList?.find(c => c.ColorId?.toString() === id);
  const colorData = location.state?.color || colorFromList || null;

  const handleSubmit = (data) => {
    updateColorRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/color');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/color" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('colors')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateColor')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateColor')}</h4>
              {colorData?.ColorId && (
                <small className="text-muted">{t('id')}: {colorData.ColorId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {colorData ? (
                <ColorInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateColorData}
                  initialData={colorData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <div className="text-muted">{t('noDataFound')}</div>
                  <button className="btn btn-primary mt-3" onClick={handleCancel}>
                    {t('backToColorList')}
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateColorData: state.colorReducer.updateColorData,
  colorList: state.colorReducer.colorList,
});

const mapDispatchToProps = (dispatch) => ({
  updateColorRequest: (payload) => dispatch(updateColorRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateColor);
